import {
  BpkBox,
  BpkBreakpoint,
  BpkFlex,
  BpkSpacing,
  BpkVessel,
} from '@skyscanner-internal/backpack-web/bpk-component-layout';
import BpkPanel from '@skyscanner-internal/backpack-web/bpk-component-panel';

import STYLES from './PlaceholderFlightEntry.module.scss';

const PlaceholderFlightEntry = () => {
  const airlineIconEl = (
    <div className={STYLES.PlaceholderFlightEntry__airlineIcon} />
  );
  const airlineEl = <div className={STYLES.PlaceholderFlightEntry__airline} />;
  const flightCodeEl = (
    <div className={STYLES.PlaceholderFlightEntry__flightCode}>
      <div className={STYLES.PlaceholderFlightEntry__flightCodeShimmer} />
    </div>
  );
  // `flex-grow: initial` (CSS-wide keyword resetting to 0) confirmed
  // byte-identical to a numeric `grow={0}` via live visual regression
  // (0.0000% noise, mobile + desktop viewports, en-GB + ar-AE) — see
  // WOM-6814-codeshare-placeholderflightentry.md Gap 3.
  const locationEl = (
    <BpkFlex grow={{ base: 1, [BpkBreakpoint.SmallTablet]: 0 }}>
      <div className={STYLES.PlaceholderFlightEntry__locationShimmer} />
    </BpkFlex>
  );
  const timeEl = (
    <div className={STYLES.PlaceholderFlightEntry__scheduledTime} />
  );
  const terminalEl = (
    <div className={STYLES.PlaceholderFlightEntry__terminal} />
  );
  const gateEl = <div className={STYLES.PlaceholderFlightEntry__gate} />;
  const statusEl = <div className={STYLES.PlaceholderFlightEntry__status} />;

  return (
    <BpkPanel className={STYLES.PlaceholderFlightEntry}>
      {/*
        __wrapperMobile/__wrapper/__wrapperInner stay BpkVessel + the
        original SCSS breakpoint mixin: the mobile/desktop swap here is a
        responsive `display` toggle, which jsdom's getComputedStyle never
        evaluates (always resolves to the `base` value) — see
        backpack-api-gaps.md Gap 3. A BpkBox responsive `display` prop would
        make both trees resolve to the same (ambiguous) visibility in Jest.
      */}
      <BpkVessel
        as="div"
        className={STYLES.PlaceholderFlightEntry__wrapperMobile}
      >
        <BpkFlex align="center">
          {airlineIconEl}
          {airlineEl}
          {flightCodeEl}
          <BpkFlex direction="column" align="flex-end" gap={BpkSpacing.SM}>
            {terminalEl}
            {gateEl}
          </BpkFlex>
        </BpkFlex>
        <BpkBox
          marginStart={{
            base: BpkSpacing.XL,
            [BpkBreakpoint.SmallTablet]: BpkSpacing.None,
          }}
        >
          {timeEl}
          <BpkBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            {locationEl}
            {statusEl}
          </BpkBox>
        </BpkBox>
      </BpkVessel>

      <BpkVessel as="div" className={STYLES.PlaceholderFlightEntry__wrapper}>
        <BpkVessel
          as="div"
          className={STYLES.PlaceholderFlightEntry__wrapperInner}
        >
          <BpkFlex align="center" basis="16%" minWidth="12rem">
            {airlineIconEl}
            {airlineEl}
          </BpkFlex>
          {flightCodeEl}
          <BpkFlex basis="10%">{timeEl}</BpkFlex>
          {locationEl}
          {statusEl}
          <BpkFlex
            direction="column"
            align="flex-end"
            basis="13%"
            minWidth="6rem"
            gap={BpkSpacing.SM}
          >
            {terminalEl}
            {gateEl}
          </BpkFlex>
        </BpkVessel>
      </BpkVessel>
    </BpkPanel>
  );
};

export default PlaceholderFlightEntry;
